import { useCallback, useRef, useState } from 'react';

interface TimerOptions {
  duration: number; // 전체시간 (s)
  interval?: number; // 실행시간 (s) , default: 1초
  onTick?: (tick: number, duration: number, interval: number) => void; // 초 단위로 전달
  onComplete?: () => void;
}

export const useTimer = ({ duration, interval = 1, onTick, onComplete }: TimerOptions) => {
  const durationMs = duration * 1000;
  const intervalMs = interval * 1000;

  const [tick, setTick] = useState(0); //ms

  const timerRef = useRef<number | null>(null);

  const clear = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const start = useCallback(() => {
    console.log('useTimer start');
    clear();

    timerRef.current = window.setInterval(() => {
      setTick((prev) => {
        const next = prev + intervalMs;

        onTick?.(next / 1000, duration, interval); // 초로 전달

        if (next >= durationMs) {
          clear();
          onComplete?.();
          return durationMs;
        }

        return next;
      });
    }, intervalMs);
  }, [durationMs, intervalMs, onTick, onComplete]);

  const reset = useCallback(() => {
    clear();
    setTick(0);
  }, []);

  const restart = useCallback(() => {
    clear();
    setTick(0);
    start();
  }, []);

  const stop = useCallback(() => {
    clear();
  }, []);

  return {
    tick: tick / 1000, //초
    remaining: Math.max((durationMs - tick) / 1000, 0), //초
    isRunning: timerRef.current !== null,
    start,
    stop,
    reset,
    restart,
  };
};
